<sc-paged-content [data]="equipmentType?.equipments || []" [configuration]="configuration"
  (addRequested)="onAddRequested()" (selectionChanged)="onSelectionChanges($event)">
  <sc-no-data-container fitHeight [hasData]="currentInstance != null">
    <sc-padding>
      <ng-container [formGroup]="formGroup">
        <sc-string-field formControlName="identifier"
          labelDictionaryKey="tmc-common.equipment.entity.equipment-instance.identifier"></sc-string-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-checkbox-field formControlName="disabled"
          labelDictionaryKey="tmc-common.equipment.entity.equipment-instance.disabled"></sc-checkbox-field>
      </ng-container>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-formular-component [context]="{layout: layout!, detailLayoutItemProvider: itemProvider }"
        [model]="currentInstanceDetails" (changed)="handleMaskChanged()"></sc-formular-component>
    </sc-padding>
  </sc-no-data-container>
</sc-paged-content>
